import { useLayoutEffect, useRef } from 'react';
import { Box } from '@tonic-one/react';

// Type definitions for the Credit Drawer API
interface DrawerHandlers {
  open: () => void;
  close: () => void;
}

interface FeatureData {
  enablement?: Record<string, boolean>;
  package?: Record<string, number | string | boolean>;
  extraInfo?: unknown;
}

type RenderDrawerFunc = (options: {
  el: HTMLElement;
  container: HTMLElement;
  app: string;
  fetchData?: () => Promise<FeatureData>;
  onSubmit?: (
    updatedPayload: FeatureData,
    originalPayload: FeatureData
  ) => Promise<void>;
  handler?: React.RefObject<DrawerHandlers>;
}) => void;

interface CreditInAppFeature {
  renderDrawerButton: RenderDrawerFunc;
}

interface CreditDrawerButtonProps {
  fetchData?: () => Promise<FeatureData>;
  onSubmit?: (
    updatedPayload: FeatureData,
    originalPayload: FeatureData
  ) => Promise<void>;
}

const APP_CODE = 'V1_EMAILSECURITY';

const CreditDrawerButton = ({
  fetchData,
  onSubmit,
}: CreditDrawerButtonProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const drawerRef = useRef<DrawerHandlers>({
    open: () => {
      // placeholder
    },
    close: () => {
      // placeholder
    },
  });

  useLayoutEffect(() => {
    const topWindow = window.top as
      | (Window & { creditInAppFeature?: CreditInAppFeature })
      | null;
    if (ref.current && topWindow?.creditInAppFeature?.renderDrawerButton) {
      topWindow.creditInAppFeature.renderDrawerButton({
        el: ref.current,
        container: document.head,
        app: APP_CODE,
        fetchData,
        onSubmit,
        handler: drawerRef,
      });
    }
  }, [fetchData, onSubmit]);

  return <Box ref={ref} />;
};

export default CreditDrawerButton;
